import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import {IDataToSendForPasswordValidation} from './pre-login.model';
import { LoggedInUserDeails } from './login.model';

@Injectable({
  providedIn: 'root'
})
export class ValidateUserPasswordService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  validateUserInformation(data: IDataToSendForPasswordValidation): Observable<LoggedInUserDeails> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   const result= this.httpClient.post(environment.servicePath + '/lfuser/validate_password', data, { headers});
   return result as Observable<LoggedInUserDeails>;


  }
}
